import { render } from "./CardBlock.vue?vue&type=template&id=4c1d5cc5&scoped=true"
import script from "./CardBlock.vue?vue&type=script&lang=js"
export * from "./CardBlock.vue?vue&type=script&lang=js"

import "./CardBlock.vue?vue&type=style&index=0&id=4c1d5cc5&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1d5cc5"]])

export default __exports__